import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Box, ListItem, ListItemIcon } from '@mui/material';
import { config } from '@converge/config';
import './app-drawer.scss';
import { useNavigate } from 'react-router-dom';
import { ConvergeIcon } from '@converge/ui';

interface IConvergeAppDrawer {
  isDrawerOpen: boolean;
  onClose: () => void;
}

interface IMenuItem {
  label: string;
  path: string;
  icon: JSX.Element;
}

const MENU_ITEMS: IMenuItem[] = [
  {
    label: 'Submissions',
    icon: <ConvergeIcon type="submissions" />,
    path: '/underwriting',
  },
  {
    label: 'Insureds',
    icon: <ConvergeIcon type="insureds" />,
    path: '/insureds',
  },
  {
    label: 'Claims',
    icon: <ConvergeIcon type="brokers" />,
    path: '/claims',
  },
];

export default function ConvergeAppDrawer({
  isDrawerOpen,
  onClose,
}: IConvergeAppDrawer) {
  const navigate = useNavigate();

  const handleListItemClick = (menuItem: IMenuItem) => {
    navigate(menuItem.path);
    window.setTimeout(() => {
      onClose();
    }, 500);
  };

  return (
    <Drawer open={isDrawerOpen} onClose={onClose}>
      <Box className="app-drawer-logo-wrapper">
        <img src={config.logo} className="app-drawer-logo" alt="logo" />
      </Box>
      <List component="nav" aria-label="application menus">
        {MENU_ITEMS.map((currentItem) => {
          return (
            <ListItem key={currentItem.label} disablePadding>
              <ListItemButton onClick={() => handleListItemClick(currentItem)}>
                <ListItemIcon>{currentItem.icon}</ListItemIcon>
                <ListItemText
                  primary={currentItem.label}
                  sx={{ paddingRight: 5 }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Drawer>
  );
}
